export class Connector {
  public constructor(
    /** Generated unique ID, not related to the Connector */
    public id: string,
    public materialNumber: string,
    public topMainGroupId: string,
    public topConnector: string,
    public mainConnector: string,
    public subConnector: string,
    public createdBy: string,
    public createdOn?: Date
  ) {}
}
